<template>
  <nav v-if="numPages > 1" class="pagination-nav">
    <ul class="pagination">
      <li v-for="page in numPages" :key="page"
          class="page-item"
          :class="{active: (value + 1 === page)}" @click="$emit('input', page - 1)"
      >
        <span class="page-link">
          {{ page }}
        </span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
    name: 'Paginator',
    components: {
    },
    props: {
        value: {
            type: Number,
            required: true,
            default: _ => 0,
        },
        numPages: {
            type: Number,
            required: true,
            default: _ => 0,
        },
    },
}
</script>
